export default __webpack_public_path__ + "static/media/sprinkler-center.83da720f.png";